package com.sddamico.draftmachine.ds.feedback

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.DmSpacing
import com.sddamico.draftmachine.ds.Icon
import com.sddamico.draftmachine.ds.IconWeight
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.displayInlineFlex
import com.sddamico.draftmachine.ds.roleH2
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/**
 * A "cold machine" empty state — a big idle gear, headline, message, and an optional action slot.
 * Port of `components/feedback/EmptyState.jsx`.
 */
@Composable
fun EmptyState(
  title: String? = null,
  message: String? = null,
  icon: String = "gear-six",
  modifier: Modifier = Modifier,
  action: (@Composable () -> Unit)? = null,
) {
  Div(
    attrs = modifier
      .displayFlex().flexDirection(FlexDirection.Column).alignItems(AlignItems.Center)
      .gap(DmSpacing.space4).padding(topBottom = DmSpacing.space12, leftRight = DmSpacing.space6)
      .styleModifier { property("text-align", "center") }
      .toAttrs()
  ) {
    Div(attrs = Modifier.position(Position.Relative).displayInlineFlex().toAttrs()) {
      Icon(icon, IconWeight.Fill, Modifier.fontSize(64.px).color(DmColor.steel600))
      Icon(
        "gear", IconWeight.Fill,
        Modifier.position(Position.Absolute).right((-14).px).bottom((-10).px)
          .fontSize(32.px).color(DmColor.steel700)
      )
    }
    Div(attrs = Modifier.toAttrs()) {
      if (title != null) {
        Div(attrs = Modifier.roleH2().margin(bottom = 6.px).toAttrs()) { Text(title) }
      }
      if (message != null) {
        P(attrs = Modifier.color(DmColor.textMuted).maxWidth(360.px).toAttrs()) { Text(message) }
      }
    }
    action?.invoke()
  }
}
